import React from 'react'
import PropTypes from 'prop-types'
import AccessKeys from './AccessKeys'
import css from './ManageAccessKeys.css'
import NewAccessKey from "./NewAccessKey";

/**
 * Displays the Access tab subsection in the Data Extracts Tenant Admin page. This section displays a table that
 * lists access keys, creates new keys, and deletes existing keys. This component is only displayed
 * if data extracts are enabled for the tenant.
 *
 * @param {Object} props - see propTypes
 * @returns {JSX.Element} The Access tab subsection of the tenant admin User Extracts page
 */
const ManageAccessKeys = (props) => {

    return <div>
        <div className={css['tab-header']}>Access Keys</div>
        <NewAccessKey isOpen={props.isOpenNewAccessKey}
                      setIsOpen={props.setIsOpenNewAccessKey}
                      selectedOption={props.selectedOption}
                      setSelectedOption={props.setSelectedOption}
                      onCancel={props.onNewAccessKeyCancel}
                      onClose={props.onNewAccessKeyCancel}
                      createUser={props.createUser}
                      userCreated={props.userCreated}
                      userCredentials={props.userCredentials}
                      showSecretKey={props.showSecretKey}
                      onClickShowSecretKey={props.onClickShowSecretKey}
        />
        <p className={css['text']}>{props.maxAccessKeys - props.userList.length} access key(s) remaining.</p>
        <AccessKeys userList={props.userList}
                    setIsOpenDeleteAccessKey={props.setIsOpenDeleteAccessKey}
                    setDeleteUserName={props.setDeleteUserName}
                    setIsOpenUpdateAccessKeyStatus={props.setIsOpenUpdateAccessKeyStatus}
                    onAccessKeyStatusChange={props.onAccessKeyStatusChange}
        />
    </div>
}

ManageAccessKeys.propTypes = {
    userList: PropTypes.arrayOf(PropTypes.object),
    isOpenNewAccessKey: PropTypes.bool.isRequired,
    setIsOpenNewAccessKey: PropTypes.func.isRequired,
    selectedOption: PropTypes.object,
    setSelectedOption: PropTypes.func.isRequired,
    onNewAccessKeyCancel: PropTypes.func.isRequired,
    createUser: PropTypes.func.isRequired,
    userCreated: PropTypes.bool.isRequired,
    userCredentials: PropTypes.object,
    setIsOpenDeleteAccessKey: PropTypes.func.isRequired,
    setDeleteUserName: PropTypes.func.isRequired,
    maxAccessKeys: PropTypes.number.isRequired,
    showSecretKey: PropTypes.bool.isRequired,
    onClickShowSecretKey: PropTypes.func.isRequired,
    setIsOpenUpdateAccessKeyStatus: PropTypes.func.isRequired,
    onAccessKeyStatusChange: PropTypes.func.isRequired
}

export default ManageAccessKeys
